import { render, staticRenderFns } from "./StudentsUnion.vue?vue&type=template&id=0629f46c&scoped=true&"
import script from "./StudentsUnion.vue?vue&type=script&lang=js&"
export * from "./StudentsUnion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629f46c",
  null
  
)

export default component.exports